import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  InputAdornment,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  ListItemButton,
  ListItemIcon,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { Refresh, Search } from '@mui/icons-material';


/**
 * Props:
 * - open: boolean
 * - slotId: string | number
 * - slotLabel: string
 * - initialValues?: { nombre?: string, documento?: string }  // para ocupar o para liberar (puede venir prellenado)
 * - onCancel: () => void
 * - onConfirm: (payload: { slotId, slotLabel, nombre, documento }) => void
 */
export default function BusquedaDialog({
  open,
  espacio,
  onCancel,
  onConfirm,
}) {
  const [data, setData] = React.useState('');
  const [valorDeBusqueda, setValorDeBusqueda] = React.useState("");
  const [okParaFiltrar, setOkParaFiltrar] = React.useState(true);

  const [reservasDelEspacio, setReservasDelEspacio] = React.useState([]);
  const [reservas, setReservas] = React.useState([]);

  const [reservasCount, setReservasCount] = React.useState(0);
  const [reservasDelEspacioCount, setReservasDelEspacioCount] = React.useState(0);

  const actualizarReservasDelEspacio = () => {
    setReservasDelEspacio(espacio?.slots.filter(slot => !!slot.visitante).map(slot => {return {ubicacion: slot, visitante: slot.visitante}}) ?? []);
  }

  const handleConfirmar = (item) => {
    item.ubicacion.visitante = item.visitante;
    onConfirm?.(item);
  };

  const handleClose = () => {
    onCancel();
  }

  const adpotarDatosDelDNI = (data) => {
    // @30926777    @A@1@TAGLIAZUCCHI@MATIAS EDUARDO@ARGENTINA@06-05-1984@M@14-04-2011@00045699471@8028 @14-04-2026@697@0@ILRÑ2.01 CÑ110223.01 )No Cap.=@UNIDAD #16 ]] S-NÑ 0040:2008::0021
    // 00319299845@BORELLI@JAVIER ALEJANDRO@M@25380486@A@26-05-1976@06-12-2014@207
    const DNI = data.split('@');
    console.log('DNI leido', data,DNI);
    let nombreStr = '';
    let documentoStr = '';
    if (DNI[0] == '') {
      nombreStr = (DNI[5] ?? '') + ' ' + (DNI[4] ?? '');
      documentoStr = DNI[1]?.trim() ?? '';
    } else {
      nombreStr = (DNI[2] ?? '') + ' ' + (DNI[1] ?? '');
      documentoStr = DNI[4] ?? '';
    }
    setValorDeBusqueda(documentoStr ?? '');
  }

  const limpiarBusqueda = () => {
    setValorDeBusqueda('');
    setOkParaFiltrar(true);
  }

  const filtrarBusqueda = () => {
    if (valorDeBusqueda.includes('@')) {
      adpotarDatosDelDNI(valorDeBusqueda);
    }
    setOkParaFiltrar(true);

  }

  const handleKeyUp = (event) => {
    if (event.key == 'Enter') {
      filtrarBusqueda();
    }
  }

  React.useEffect(() => {
    if (reservasDelEspacio.length > 0) {
      if (okParaFiltrar) {
        setReservas(reservasDelEspacio.filter(item => item.visitante.nombre.toLowerCase().includes(valorDeBusqueda.toLowerCase()) || item.visitante.documento.toLowerCase().includes(valorDeBusqueda.toLowerCase())))
        setOkParaFiltrar(false);
        setValorDeBusqueda('');
      }
    } else {
      setReservas([]);
    }
  }, [reservasDelEspacio, valorDeBusqueda, okParaFiltrar]);

  React.useEffect(() => {
    setReservasCount(reservas.length);
    setReservasDelEspacioCount(reservasDelEspacio.length);
  }, [reservas, reservasDelEspacio])

  React.useEffect(() => {
    actualizarReservasDelEspacio();
  }, [espacio]);

  return (
    <Dialog
      open={open}
      disableRestoreFocus
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      sx={{zIndex: 10}}
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ pr: 6 }}>
        Busqueda de Visitante
        <IconButton
          onClick={handleClose}
          aria-label="Cerrar"
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            Ingrese toda o parte de la información
          </Typography>

          <TextField
            label="Nombre o Documento"
            value={valorDeBusqueda}
            onChange={(e) => setValorDeBusqueda(e.target.value)}
            onKeyUp={handleKeyUp}
            autoFocus
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonOutlineIcon fontSize="small" />
                  </InputAdornment>
                ),
                endAdornment: (
                  !!valorDeBusqueda
                    ? <IconButton
                      onClick={filtrarBusqueda}
                      aria-label="Filtrar"
                    >
                      <Search />
                    </IconButton>
                    : (reservasCount < reservasDelEspacioCount) && <IconButton
                      onClick={limpiarBusqueda}
                      aria-label="Limpiar"
                    >
                      <Refresh />
                    </IconButton>
                )
            }}}
          />
          <Typography fontSize="small">{ reservasCount + '/' + reservasDelEspacioCount }</Typography>


          {/* <Button variant="outlined" startIcon={<PersonSearch />} onClick={handleBuscar}>Buscar</Button> */}
          <List>
            {(reservas.length == 0) && <ListSubheader>No hay reservas que coincidan</ListSubheader>}
            {reservas.map((item) => {
              return (
                <ListItem key={item.ubicacion.id} disablePadding>
                  <ListItemButton onClick={() => handleConfirmar(item)}>
                    {/* <ListItemText primary={'Ubicación: ' + item.ubicacion.label} /> */}
                    {/* <ListItemText primary={item.visitante.nombre} secondary={item.visitante.documento} /> */}
                    <ListItemIcon><PlaceOutlinedIcon />{item.ubicacion.label}</ListItemIcon>
                    <ListItemText primary={item.visitante.nombre} />
                    <ListItemText primary={item.visitante.documento} sx={{textAlign: 'right'}} />
                  </ListItemButton>
                </ListItem>
            )})}
          </List>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={handleClose} variant="outlined">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
